// Absolute URL for a game-served path under /assets. Production sets
// REACT_APP_AETERNA_ASSET_URL to the Cloudflare Pages asset domain; otherwise
// assets come from the API host (REACT_APP_AETERNA_API_URL) or same origin.
function trimBase(value) {
  return value ? String(value).replace(/\/$/, "") : "";
}

export function resolveAeternaAssetPath(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  // No `typeof process` guard: CRA inlines these at build time, but `process`
  // itself is undefined in the browser, so a guard would always skip them.
  const envBase =
    trimBase(process.env.REACT_APP_AETERNA_ASSET_URL) ||
    trimBase(process.env.REACT_APP_AETERNA_API_URL);
  if (envBase) {
    return `${envBase}${normalized}`;
  }
  if (typeof window !== "undefined") {
    const { hostname } = window.location;
    if (
      hostname.endsWith(".itch.io") ||
      hostname.endsWith(".itch.zone") ||
      hostname.endsWith(".hwcdn.net")
    ) {
      return `https://aeternainvicta.com${normalized}`;
    }
  }
  return normalized;
}
